module.exports = "<div class=\"spinner-wrapper\"><div [ngClass]=\"status\" [ngStyle]=\"styleObj\" class=\"spinner\"  ></div></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/spinner-with-check-mark/spinner-with-check-mark.component.html
// module id = ./src/app/common/spinner-with-check-mark/spinner-with-check-mark.component.html
// module chunks = main